import React from 'react';

import { useLoginStyles } from 'consts/styles/Login';

const Copyright = () => {
  const classes = useLoginStyles();
  return (
    <div className={`${classes.Login}__copyright`}>
      {'\u00A9'} {new Date().getFullYear()} Zodiac DTM
    </div>
  );
};

export default Copyright;
